import React from "react";
import "./operational.less";
import OperationalMetricsTable from "./Compare Table/table";

const InvITsOperational: React.FC = () => {
  const displayName = "cmp-compare-reits";

  return (
    <div className={displayName}>
      <section className={`${displayName}__hero-banner`}>
        <div className={`${displayName}__hero-text`}>
          <h1>
            Compare <span>InvITs Operational Metrics</span>
          </h1>
          <p>
            Whether you're just exploring or ready to commit, use our comparison
            tool to evaluate platforms side-by-side — and choose the one that
            fits your financial goals.
          </p>
        </div>
      </section>
      <OperationalMetricsTable />
    </div>
  );
};

export default InvITsOperational;
